import { useEffect, useMemo } from "react";
import { useGetMediaCategories } from "../";
import { useMediaGenreListSelector } from "../../selectors";

export const useMediaGenreList = () => {
  const getMediaCategories = useGetMediaCategories();
  const { data, isLoading } = useMediaGenreListSelector();

  useEffect(() => {
    getMediaCategories(true);
  }, []);

  return useMemo(
    () => ({ data, isLoading: !data.length && isLoading }),
    [data, isLoading]
  );
};
